export default "__VITE_ASSET__eafe1d38__"